export const mimeTypes = {
  APPLICATION_PDF: 'application/pdf',
  APPLICATION_XML: 'application/xml',
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  EXCEL_OLD: 'application/vnd.ms-excel',
  APPLICATION_ZIP: 'application/zip',
  IMAGE: 'image/*',
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};
